import Alpine from "alpinejs";
import collapse from "@alpinejs/collapse";

Alpine.plugin(collapse);

window.Alpine = Alpine;

// Protección contra doble inicialización
if (!window.alpineStarted) {
    window.alpineStarted = true;
    console.log("🚀 Iniciando Alpine.js");
    Alpine.start();
} else {
    console.warn("⚠️ Alpine ya fue inicializado, omitiendo start()");
}
